import { useMemo } from 'react';
import { DeviceProvider as SeagullDeviceProvider } from 'seagull';
import { useFeatureFlags } from "../hooks/useFeatureFlags";
import { jsx as _jsx } from "react/jsx-runtime";
export function DeviceProvider(_ref) {
  let {
    children,
    isMobileDevice
  } = _ref;
  const {
    MOBILE_RESPONSIVENESS = false
  } = useFeatureFlags();
  const value = useMemo(() => ({
    isMobileDeviceOLD: isMobileDevice,
    isMobileDevice: MOBILE_RESPONSIVENESS && isMobileDevice
  }), [isMobileDevice, MOBILE_RESPONSIVENESS]);
  return /*#__PURE__*/_jsx(SeagullDeviceProvider, {
    value: value,
    children: children
  });
}